module.exports = __webpack_public_path__ + "img/birgand.e6f5f457.jpg";